// AssetDropdown.tsx

import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { getTokenTitle, validPair } from "./AmountAndAssetForm";
import StellarAsset from "../../api/types/stellarAsset";
import EthereumAsset from "../../api/types/ethereumAsset";
import { NervosAsset } from "../../api/types/nervosAsset";

interface AssetDropdownProps {
  assets: Map<string, EthereumAsset | StellarAsset | NervosAsset>;
  selectedAsset?: string;
  otherAsset?: string;
  chainID?: bigint[];
  onSelectAsset: (assetID: string | null) => void;
}

const AssetDropdown: React.FC<AssetDropdownProps> = ({
  assets,
  selectedAsset,
  otherAsset,
  chainID,
  onSelectAsset,
}) => {
  return (
    <DropdownButton
      id={"asset-button"}
      className={"btn-block"}
      variant="outline-secondary"
      title={
        selectedAsset && assets.has(selectedAsset)
          ? getTokenTitle(assets.get(selectedAsset)!, false, true)
          : "Select Token"
      }
      onSelect={onSelectAsset}
    >
      {chainID && (
        <>
          {Array.from(assets.values())
            .filter((a) => chainID.includes(a.chainID))
            .map((a) => (
              <Dropdown.Item
                key={a.assetID()}
                eventKey={a.assetID()}
                disabled={
                  otherAsset
                    ? a.assetID() === otherAsset ||
                      !validPair(a, assets.get(otherAsset!)!)
                    : false
                }
              >
                {getTokenTitle(a, true, false)}
              </Dropdown.Item>
            ))}
        </>
      )}
      {!chainID && (
        <>
          {Array.from(assets.values()).map((a) => (
            <Dropdown.Item
              key={a.assetID()}
              eventKey={a.assetID()}
              disabled={
                otherAsset
                  ? a.assetID() === otherAsset ||
                    !validPair(a, assets.get(otherAsset!)!)
                  : false
              }
            >
              {getTokenTitle(a, true, false)}
            </Dropdown.Item>
          ))}
        </>
      )}
    </DropdownButton>
  );
};

export default AssetDropdown;
